import type { GetServerSidePropsContext, NextApiRequest, NextApiResponse } from 'next'

import { DEFAULT_ERROR_MESSAGE } from '../constants'
import type { AuthBackendUpstreamVariant, SigninUpstream } from '../experiments'
import {
  AUTH_BACKEND_UPSTREAM_VARIANTS,
  commitAuthMigrationVariant,
  getAuthServerUrl,
  isSigninRolloutActive,
  SIGNIN_UPSTREAM_VALUES,
} from '../experiments'
import { internalAuthApi } from './internal-auth-api'

export async function authBootstrapCsrfHandler(
  req: NextApiRequest,
  res: NextApiResponse
): Promise<void> {
  if (req.method !== 'GET') {
    res.setHeader('Allow', 'GET')
    res.status(405).end()
    return
  }

  const flow = req.query.flow === 'rollout' ? 'rollout' : 'stable'
  const ctxLike = { req, res, query: req.query } as unknown as GetServerSidePropsContext

  let variant: AuthBackendUpstreamVariant | undefined
  let upstream: SigninUpstream | undefined
  if (flow === 'rollout') {
    if (!isSigninRolloutActive()) {
      res.status(200).json({ csrfToken: null, upstream: SIGNIN_UPSTREAM_VALUES.BIFROST })
      return
    }
    variant = AUTH_BACKEND_UPSTREAM_VARIANTS.AUTH_SERVER
    upstream = SIGNIN_UPSTREAM_VALUES.AUTH_SERVER
  }
  const baseUrl = getAuthServerUrl()

  if (!baseUrl) {
    res.status(200).json({ csrfToken: null, upstream })
    return
  }

  try {
    const { csrfToken } = await internalAuthApi.getCsrfToken(ctxLike, { baseUrl })
    if (variant) commitAuthMigrationVariant(ctxLike, variant)
    res.status(200).json({ csrfToken, upstream })
  } catch {
    console.error('[CSRF Token] Failed to get CSRF token from auth-server')
    res.status(500).json({ message: DEFAULT_ERROR_MESSAGE })
  }
}
